import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import { navigate } from '@reach/router'
import { Form } from 'react-final-form'
import classNames from 'classnames'

import { signupValidation } from '../../lib/validators'
import TextInput from '../ui/form/TextInput'
import MailInput from '../ui/form/MailInput'
import PasswordInput from '../ui/form/PasswordInput'
import DocFields from '../people/form/DocFields'
import { autoRegisterMutation } from '../../lib/graphql/people'

class SignupForm extends React.Component {
  render() {
    return (
      <Mutation
        mutation={autoRegisterMutation}
        onCompleted={(data) => {
          this.props.onCompleted(data)
        }}
        onError={(error) => {
          this.props.onError(error)
        }}
      >
        {(autoRegister) => (
          <Form
            validate={signupValidation}
            onSubmit={async (values) => {
              this.props.onSubmit()
              await autoRegister({ variables: { input: values } })
            }}
          >
            {({ handleSubmit, submitting, form }) => (
              <form onSubmit={handleSubmit}>
                <DocFields form={form} />

                <MailInput
                  name="email"
                  label="Endereço de e-mail"
                  checkAvailabilityOnCav={true}
                  checkAvailabilityOnUFFS={true}
                  autoComplete="off"
                />

                <TextInput name="firstName" label="Nome" autoComplete="off" />

                <TextInput
                  name="lastName"
                  label="Sobrenome"
                  autoComplete="off"
                />

                <PasswordInput
                  name="password"
                  label="Senha"
                  helpText="A senha deve conter mais de 8 caracteres entre letras e números"
                  autoComplete="current-password"
                />

                <PasswordInput
                  name="passwordConfirmation"
                  label="Confirme sua senha"
                  autoComplete="current-password"
                />

                <button
                  className={classNames(
                    'button is-primary is-medium is-fullwidth',
                    {
                      'is-loading': submitting,
                    }
                  )}
                  type="submit"
                >
                  Enviar
                </button>

                <button
                  onClick={(e) => {
                    e.preventDefault()
                    navigate('/forgot-password')
                  }}
                  className="button is-text"
                >
                  Esqueceu sua senha?
                </button>
              </form>
            )}
          </Form>
        )}
      </Mutation>
    )
  }
}

SignupForm.propTypes = {
  onSubmit: PropTypes.func,
  onCompleted: PropTypes.func,
  onError: PropTypes.func,
}

SignupForm.defaultProps = {
  onSubmit: () => {},
  onCompleted: () => {},
  onError: () => {},
}

export default SignupForm
